module.exports = __webpack_public_path__ + "img/kings_residence.05519a86.jpg";